import styled from "styled-components";
import Ruta from "./ruta.jsx"
import rutaExcel from "../../imgs/rutaExel.png"
import operando from "../../imgs/operando.jpg"
import inagura from "../../imgs/inagura.png"
import {useSelector} from 'react-redux';
import { useNavigate, } from 'react-router-dom';
import { useEffect } from 'react';





const Container=styled.div`
	display:flex;
	height:100vh;
	width:100vw;
	background-color:black;
	@media (max-width:900px) {
    	


  	};

`;

const Mask=styled.div`
	display:flex;
	flex-direction:row; 
	height:82vh;
	width:150vw;
	position:absolute;
	left:-70px;
	overflow:hidden;	
	@media (max-width:900px) {
    	flex-direction:column;
    	overflow:auto;
    	height:100%;
    	left:0px;


    &::-webkit-scrollbar{
		background-color:white;
		width:5px};
	::-webkit-scrollbar-thumb{
		background:#01578c;
		border-radius:25px};
	::-webkit-scrollbar:horizontal{display:none}
  	};
 `;

 const Mask2=styled.div`
	
	height:81vh;
	width:36vw;
	min-width:350px;
	@media (max-width:900px) {
    	width:100%;


  	};
	

	

	
 `;











export default function MenuRutas(){

	const navigate=useNavigate();
	const menuOpen=useSelector(state=>state.openRutas);
	const ruta=useSelector(state=>state.ruta);

	useEffect(()=>{
		if(menuOpen===1 || menuOpen==="1"){navigate(`/Home/Tutoriales/pasos/${ruta}`)}

	},[menuOpen,navigate,ruta]);

	

	return(
		<Container>	
			<Mask>
				<Mask2>		
					<Ruta rutaImg={inagura} texto="por inaugurar" ruta="1"/>
				</Mask2>
				<Mask2>				
					<Ruta rutaImg={operando} texto="ya operando" ruta="2"/>
				</Mask2>
				<Mask2>					
					<Ruta rutaImg={rutaExcel} texto="archivo excel (migracion)" ruta="3"/>
				</Mask2>	
			</Mask>
			

		</Container>


		)
}